import { useAuth } from 'contexts/AuthContext';
import { useUserProfile } from 'features/auth/hooks/useUserProfile';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../AppIcon';
import Button from './Button';

const Header = ({ className = '', sidebarCollapsed = false }) => {
  const { logout } = useAuth();
  const { data: profileData } = useUserProfile();
  const user = profileData?.data;
  const navigate = useNavigate();
  const [isUserMenuOpen, setIsUserMenuOpen] = useState(false);

  const getInitials = () => {
    const name = user?.name || 'User';
    return name
      .split(' ')
      .map((n) => n[0])
      .join('')
      .toUpperCase()
      .slice(0, 2);
  };

  const toggleUserMenu = () => {
    setIsUserMenuOpen(!isUserMenuOpen);
  };

  const handleNavigation = (path) => {
    setIsUserMenuOpen(false);
    navigate(path);
  };

  return (
    <>
      <header
        className={`fixed top-0 right-0 z-40 bg-card border-b border-border transition-all duration-300 ${
          sidebarCollapsed ? 'left-16' : 'left-64'
        } ${className}`}
      >
        <div className='flex items-center justify-between h-16 px-6'>
          {/* Left side - can add breadcrumbs or page title here if needed */}
          <div className='flex items-center'>
            {/* This space can be used for page-specific tools or breadcrumbs */}
          </div>

          {/* Right Section */}
          <div className='flex items-center space-x-4'>
            {/* Search */}
            {/* <Button variant='ghost' size='icon' className='relative'>
              <Icon name='Search' size={20} />
            </Button> */}

            {/* Notifications */}
            {/* <Button variant='ghost' size='icon' className='relative'>
              <Icon name='Bell' size={20} />
              <span className='absolute -top-1 -right-1 w-2 h-2 bg-error rounded-full pulse-status'></span>
            </Button> */}

            {/* Theme Toggle - Hidden by default */}
            {/* <Button
              variant='ghost'
              size='icon'
              onClick={toggleTheme}
              title={`Switch to ${isDark ? 'light' : 'dark'} mode`}
            >
              <Icon name={isDark ? 'Sun' : 'Moon'} size={20} />
            </Button> */}

            {/* User Menu */}
            <div className='relative'>
              <Button
                variant='ghost'
                size='icon'
                onClick={toggleUserMenu}
                className='rounded-full'
              >
                {user?.profilePhoto ? (
                  <img
                    src={user.profilePhoto}
                    alt={user?.name || 'Profile'}
                    className='w-8 h-8 rounded-full object-cover'
                  />
                ) : (
                  <div className='w-8 h-8 bg-primary rounded-full flex items-center justify-center text-white text-xs font-semibold'>
                    {getInitials()}
                  </div>
                )}
              </Button>

              {/* User Dropdown */}
              {isUserMenuOpen && (
                <div className='absolute right-0 mt-2 w-56 bg-popover border border-border rounded-md elevation-2 z-1100'>
                  <div className='py-1'>
                    <div className='px-4 py-3 border-b border-border'>
                      <p className='text-sm font-medium text-foreground'>
                        {user?.name}
                      </p>
                      <p className='text-xs text-muted-foreground'>
                        {user?.email}
                      </p>
                      {user?.role?.name && (
                        <p className='text-xs text-primary capitalize mt-1'>
                          {user?.role?.name}
                        </p>
                      )}
                    </div>
                    <button
                      className='w-full text-left px-4 py-2 text-sm text-foreground hover:bg-muted flex items-center space-x-2'
                      onClick={() => handleNavigation('/profile')}
                    >
                      <Icon name='User' size={16} />
                      <span>Profile</span>
                    </button>
                    <button
                      className='w-full text-left px-4 py-2 text-sm text-foreground hover:bg-muted flex items-center space-x-2'
                      onClick={() => handleNavigation('/settings')}
                    >
                      <Icon name='Settings' size={16} />
                      <span>Settings</span>
                    </button>
                    <div className='border-t border-border mt-1'>
                      <button
                        className='w-full text-left px-4 py-2 text-sm text-error hover:bg-muted flex items-center space-x-2'
                        onClick={logout}
                      >
                        <Icon name='LogOut' size={16} />
                        <span>Sign out</span>
                      </button>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </header>
      {/* Click outside handler for user menu */}
      {isUserMenuOpen && (
        <div
          className='fixed inset-0 z-1000'
          onClick={() => setIsUserMenuOpen(false)}
        ></div>
      )}
    </>
  );
};

export default Header;
